module.exports = __webpack_public_path__ + "static/media/virtual_account_app_logo.d9b6a961.png";